<template>
  <div class="pend-check">
    <div class="pend-check-search white-box column-content">
      <span class="span-14">姓名</span>
      <el-input class="search-input" placeholder="请输入姓名" v-model="name"></el-input>
      <span class="span-14">手机号</span>
      <el-input  class="search-input" placeholder="请输入手机号" v-model="phone"></el-input>
      <span class="span-14">身份证</span>
      <el-input  class="search-input" placeholder="请输入身份证号" v-model="idNumber"></el-input>
      <span class="span-14">申请日期</span>
      <el-date-picker
        v-model="applyDate"
        type="date"
        placeholder="选择日期">
      </el-date-picker>
      <el-button :loading="loading" type="primary" icon="search">搜索</el-button>
      <el-button>取消</el-button>
    </div>
    <div class="pend-check-table">
      <el-table
        :data="tableData"
        style="width: 100%" row-class-name="pend-table-tr">
        <el-table-column prop="name" label="姓名" width="100">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="150">
        </el-table-column>
        <el-table-column prop="idNumber" label="身份证号" width="180">
        </el-table-column>
        <el-table-column prop="mark" label="备注" width="200">
        </el-table-column>
        <el-table-column prop="date" label="日期" width="120">
        </el-table-column>
        <el-table-column prop="handle" label="操作" width="350">
            <template slot-scope="scope">
              <el-button type="text" size="small">通过</el-button>
              <el-button type="text" size="small">不通过</el-button>
            </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="penk-check-pag column-content white-box">
      <el-pagination
        :current-page.sync="currPage"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="total, sizes, prev, pager, next"
        :total="1000">
      </el-pagination>
    </div>
  </div>
</template>

<script>
    export default {
      data(){
        return {
          currPage:1,
          activeName: 'first',
          name:'',
          phone:'',
          idNumber:'',
          applyDate:'',
          loading:false,
          tableData: [{
            date: '2016-05-02',
            name: '王小虎',
            phone: '15566666666',
            idNumber:'449999999999999',
            mark: '加我as阿斯顿发送到发送的'
          }]
        }
      },
      components:{
      },
      computed: {

      },
      mounted(){

      }
    }
</script>

<style lang="scss" scoped>
.pend-check{
  &>div{
    width: 1100px;
    height: 74px;
  }
  .el-button--text{
    color:#f86442;
  }
  .penk-check-pag{
    height: 74px;
  }
  .pend-check-table{
    height: auto;
    margin-top:10px;
  }
  .pend-check-search{
    padding:20px;
    .el-input{
      margin:0 20px 0 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?26a442bd